import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Instagram, Facebook } from 'lucide-react';
const Footer = () => {
  const {
    t
  } = useTranslation();
  return <footer className="bg-accent text-accent-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Mission */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <img src="/lovable-uploads/7c51434a-17a1-48b6-ba2e-d9d163dc8cbf.png" alt="Mappa Caeli Logo" className="w-12 h-12 object-cover" />
              </div>
              <span className="font-medieval text-lg font-bold">{t("footer.logoTitle")}</span>
            </div>
            
            {/* Social Media Links */}
            <div className="mt-6">
              <h3 className="font-medieval text-primary font-semibold mb-3">{t("footer.followUs")}</h3>
              <div className="flex space-x-4">
                <a 
                  href="https://www.instagram.com/mappacaeli/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                  aria-label={t("footer.instagram")}
                >
                  <Instagram className="w-6 h-6" />
                </a>
                <a 
                  href="https://www.facebook.com/profile.php?id=61581518519284" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                  aria-label={t("footer.facebook")}
                >
                  <Facebook className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-medieval text-primary font-semibold mb-4">{t("footer.learnTitle")}</h3>
            <ul className="space-y-2 font-quest">
              <li><Link to="/bible-study" className="hover:text-primary transition-colors">{t("navigation.bibleStudy")}</Link></li>
              <li><Link to="/quest-map" className="hover:text-primary transition-colors">{t("navigation.questMap")}</Link></li>
              <li><Link to="/pilgrims-arcade" className="hover:text-primary transition-colors">{t("navigation.pilgrimsArcade")}</Link></li>
              <li><Link to="/about-us" className="hover:text-primary transition-colors">{t("navigation.aboutUs")}</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h3 className="font-medieval text-primary font-semibold mb-4">{t("footer.accountTitle")}</h3>
            <ul className="space-y-2 font-quest">
              <li><Link to="/login" className="hover:text-primary transition-colors">{t("navigation.login")}</Link></li>
              <li><Link to="/signup" className="hover:text-primary transition-colors">{t("navigation.signup")}</Link></li>
              <li><Link to="/pricing" className="hover:text-primary transition-colors">{t("footer.subscription")}</Link></li>
              <li><Link to="/donate" className="hover:text-primary transition-colors">{t("footer.donate")}</Link></li>
              <li><Link to="/dashboard" className="hover:text-primary transition-colors">{t("navigation.dashboard")}</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-medieval text-primary font-semibold mb-4">{t("footer.supportTitle")}</h3>
            <ul className="space-y-2 font-quest">
              <li><a href="mailto:support@mappa-caeli.com" className="hover:text-primary transition-colors">{t("footer.supportEmail")}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center">
          <p className="text-accent-foreground/60 font-quest text-sm">
            {t("footer.copyright")}
          </p>
          <p className="text-accent-foreground/60 font-quest text-sm mt-2">{t("footer.quote")}</p>
        </div>
      </div>
    </footer>;
};
export default Footer;